import { render, staticRenderFns } from "./ShowImageDialog.vue?vue&type=template&id=de4f9842&scoped=true"
import script from "./ShowImageDialog.vue?vue&type=script&lang=js"
export * from "./ShowImageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4f9842",
  null
  
)

export default component.exports